// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal--lpxco {
  position: absolute;
  top: 370px;
  width: 445px;
  z-index: 9;
}[dir=ltr] .modal--lpxco {
  right: 31px;
}[dir=rtl] .modal--lpxco {
  left: 31px;
}

.modalContainer--j9kDn {
  position: relative;
}

[dir] .modalContainer--j9kDn {
  padding: 20px;
}

.modalHeadline--ppLMa {
  font-size: 26px;
}

[dir] .modalCountryName--Ch6Ns {
  margin-bottom: 16px !important;
}

[dir] .modalPercentageCircle--HdOKU {
  margin: 15px auto;
}

.flagIcon--CaEdV {
  width: 40px;
}

[dir=ltr] .flagIcon--CaEdV {
  margin-left: 5px;
}

[dir=rtl] .flagIcon--CaEdV {
  margin-right: 5px;
}

.modalFlagIcon--oZ69V {
  vertical-align: top;
  min-width: 30px;
  max-width: 30px;
}

.closeButtonWrapper--nuusY {
  position: absolute;
}

[dir=ltr] .closeButtonWrapper--nuusY {
  right: 0;
}

[dir=rtl] .closeButtonWrapper--nuusY {
  left: 0;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/OverviewMultiLocationSingleSubjectInnerLocation/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAElB,UAAU;EACV,YAAY;EACZ,UAAU;AACZ,CANA;EAEE,WAAW;AAIb,CANA;EAEE,UAAW;AAIb;;AAEA;EAEE,kBAAkB;AACpB;;AAHA;EACE,aAAa;AAEf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAEE,WAAW;AACb;;AAHA;EACE,gBAAgB;AAElB;;AAHA;EACE,iBAAgB;AAElB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;AAEpB;;AAHA;EAEE,QAAQ;AACV;;AAHA;EAEE,OAAQ;AACV","sourcesContent":[".modal {\n  position: absolute;\n  right: 31px;\n  top: 370px;\n  width: 445px;\n  z-index: 9;\n}\n\n.modalContainer {\n  padding: 20px;\n  position: relative;\n}\n\n.modalHeadline {\n  font-size: 26px;\n}\n\n.modalCountryName {\n  margin-bottom: 16px !important;\n}\n\n.modalPercentageCircle {\n  margin: 15px auto;\n}\n\n.flagIcon {\n  margin-left: 5px;\n  width: 40px;\n}\n\n.modalFlagIcon {\n  vertical-align: top;\n  min-width: 30px;\n  max-width: 30px;\n}\n\n.closeButtonWrapper {\n  position: absolute;\n  right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal--lpxco`,
	"modalContainer": `modalContainer--j9kDn`,
	"modalHeadline": `modalHeadline--ppLMa`,
	"modalCountryName": `modalCountryName--Ch6Ns`,
	"modalPercentageCircle": `modalPercentageCircle--HdOKU`,
	"flagIcon": `flagIcon--CaEdV`,
	"modalFlagIcon": `modalFlagIcon--oZ69V`,
	"closeButtonWrapper": `closeButtonWrapper--nuusY`
};
export default ___CSS_LOADER_EXPORT___;
